import styled from 'styled-components';

export const OptionContainer = styled.div`
    cursor: pointer;
`;